import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { GET_USER_PROGRESS_QUERY } from '../../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService.dfc';
export const useUserProgressForLearningContent = ({
  items,
  skip
}) => {
  const {
    data: userProgressData,
    loading: userProgressDataLoading,
    error: userProgressDataError,
    apolloError
  } = useQuery(GET_USER_PROGRESS_QUERY, {
    variables: {
      requestedProgress: items.map(({
        id,
        type,
        language
      }) => ({
        id,
        type,
        language: type === 'TRACK' || type === 'LESSON' ? language === null || language === void 0 ? void 0 : language.toUpperCase() : null // filter out language for shorts and playlists
      }))
    },
    skip
  });
  return {
    // temporary fix to handle the type mismatch between the user progress data and the learning content items
    userProgressData: userProgressData === null || userProgressData === void 0 ? void 0 : userProgressData.progress,
    userProgressDataLoading,
    userProgressDataError,
    apolloError
  };
};